export const pages = {
	'landing': { id: 'landing', page: 'home', getter: () => import(/* webpackChunkName: 'landing' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'landing', getter: () => import(/* webpackChunkName: "landing" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' }
];
export const sectionsWithParent = [

];
